module.exports = __webpack_public_path__ + "assets/img/login-bg@2x.c8a5455a.png";